import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import api from '@/lib/api';

import { FormButton } from '@/ui/Form';
import PublicShareDialog from '@/ui/PublicPage/PublicShareDialog';
import DialogContext from '@/ui/DialogContext/DialogContext';

const FormButtonShareExcursion = (props: { id: string | undefined }) => {
  const { t } = useTranslation();
  const dialogContext = useContext(DialogContext);
  const apiInstance = new api();

  const { id } = props;

  const handleShare = () => {
    const config = {
      position: undefined,
      extent: undefined,
      maplayers: undefined,
      route_points: undefined,
      obilaznica_id: undefined,
    };

    const object_uuid = id; 

    const data = {
      config: JSON.stringify(config),
      object_uuid,
      object_type: 'izlet',
    };

    apiInstance.Call('share-generate', 'post', data).then((resp) => {
      // @ts-ignore
      if (resp.success && resp?.data?.url_hash) {
        // @ts-ignore
        const shareUrl = `${window.location.origin}/web-share?hash=${resp.data.url_hash}`;

        dialogContext.showDialog(PublicShareDialog, { url: shareUrl });
      }
    });
  };

  return (
    <FormButton
      fullWidth={false}
      variant="contained"
      onClick={handleShare}
      sx={
        {
          /* this removes margin hardcoded into FormButton */
        }
      }
    >
      {t('buttons.share_excursion')}
    </FormButton>
  );
};

export default FormButtonShareExcursion;
